import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import SAlert from "components/Alert"
import { getProviderOuts } from "store/provider-out/provider-out-action"
import useSearch from "hooks/useSearch"
import ProviderOutDetailModal from "components/ProviderOut/details"
import ProviderDistributionActionRequestListComponent from "components/ProviderActionRequests/Distributions/list"
import {
  getProviderDistributionActionRequests,
  sendProviderDistributionActionRequests,
} from "store/provider-action-requests/provider-action-request-action"
import {
  getIps,
  getItemCategories,
  getProjects,
  getProvinces,
} from "store/admin/admin-dashboard-action"

const ProviderDistributionActionRequestList = () => {
  document.title = "Distributions"

  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(
    state => state.provActionRequests
  )
  const [deleteModal, setDeleteModal] = useState(false)
  const [proOut, setProOut] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)

  // Handle multiple delete action when top delete button is clicked
  const onAllDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(sendProviderDistributionActionRequests(ids, "Delete"))
    } else {
      SAlert({ text: "no receipt selected", status: "info" })
    }
  }
  // Handle cancel action for multiple delete when cancel button is clicked
  const onCancelDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(sendProviderDistributionActionRequests(ids, "Cancel"))
    } else {
      SAlert({ text: "no receipt selected", status: "info" })
    }
  }

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getProviderDistributionActionRequests(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getProviderDistributionActionRequests(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  // fetch new Provider Distribution Action Requests based page number or according changes
  useEffect(() => {
    dispatch(
      getProviderDistributionActionRequests(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  // fetch needed data for provider action request
  useEffect(() => {
    dispatch(getItemCategories())
    dispatch(getProvinces())
    dispatch(getIps())
    dispatch(getProjects())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(getProviderOuts(undefined, undefined, undefined, search, data))
  }

  // Show distribution details in a modal when the detail button is clicked
  const onClickDetail = data => {
    setProOut(data)
    setDetailModal(true)
  }

  return (
    <React.Fragment>
      {/* Modal Component */}
      <ProviderOutDetailModal
        open={detailModal}
        setOpen={setDetailModal}
        data={proOut}
      />

      <Breadcrumbs
        title={"Admin"}
        breadcrumbItem={"Distributions  Delete Requets"}
      />
      <ProviderDistributionActionRequestListComponent
        data={data}
        error={error}
        loading={loading}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAllDeleteClicked={onAllDeleteClicked}
        onCancelDeleteClicked={onCancelDeleteClicked}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onClickDetail={onClickDetail}
      />
    </React.Fragment>
  )
}

export default ProviderDistributionActionRequestList
